var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.328 4.492c1.457 0 2.869.587 3.9 1.619l5.647 5.643c1.019 1.046 1.605 2.443 1.605 3.886l.002.126a1.511 1.511 0 0 1 0 .466l-.002 21.76c0 3.028-2.472 5.5-5.5 5.5h-20a5.499 5.499 0 0 1-5.5-5.5v-28c0-3.041 2.454-5.5 5.5-5.5zm-1.828 3H13.98a2.493 2.493 0 0 0-2.5 2.5v28c0 1.38 1.116 2.5 2.5 2.5h20c1.372 0 2.5-1.128 2.5-2.5V17.5H30a3.493 3.493 0 0 1-3.5-3.5V7.492zM24.66 32.5a1.5 1.5 0 0 1 0 3H16a1.5 1.5 0 0 1 0-3h8.66zm3.34-6a1.5 1.5 0 0 1 0 3H16a1.5 1.5 0 0 1 0-3h12zm0-6a1.5 1.5 0 0 1 0 3H16a1.5 1.5 0 0 1 0-3h12zm1.501-12.714L29.5 14c0 .28.218.5.5.5h6.199a2.651 2.651 0 0 0-.46-.639l-5.632-5.628c-.179-.18-.384-.33-.606-.447z",
    fill: "#9EA2FA",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDocument);
export default __webpack_public_path__ + "static/media/icons-document.ff0da3f455be2afb2871798dc68f7068.svg";
export { ForwardRef as ReactComponent };